// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgx_a bhu_bi"};